import authService from 'app/services/authService';
import jwtDecode from 'jwt-decode';
import { decrypt } from './geralUtil';

export const CLIENTS_ID = {
  financeiroFront: 'financeiro-front',
  groupfinanceiroFront: 'groupfinanceiro-front',
};

export const getClientId = () => {
  const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
  return clientId;
};

export const getPortaFinanceiroApi = () => {
  const backend = process.env.REACT_APP_BASE_URL;
  const [, , porta] = backend.split(':');

  return porta;
};

export const getLoadingProcessorUrl = () => {
  const urlLoading = process.env.REACT_APP_LOADING_PROCESSOR;
  return urlLoading;
};

export const getTenant = () => {
  const token = authService.getAccessToken();
  if (token) {
    const decodedToken = jwtDecode(token);

    const [tenant] = decodedToken.tenant_id;
    const [, tenantId] = tenant.split('/');

    return tenantId;
  }

  return undefined;
};

export const getTenantToken = () => {
  const tenantId = getTenant();

  return tenantId && btoa(tenantId);
};

export const getIdUserToken = () => {
  const token = authService.getAccessToken();
  const decodedToken = jwtDecode(token);
  return decodedToken.nonce;
};

const getEmpresaId = () => {
  const empresaId = localStorage.getItem('EC');
  return btoa(decrypt(empresaId));
};

export const visualizarRelatorioV2 = (chaveFiltro) => {
  const tenantId = getTenantToken();

  const url = `/public/relatorio/pdf?key=${btoa(chaveFiltro)}&t=${tenantId}`;

  window.open(url, '_blank');
};

export const visualizarRelatorioV3 = (chavesFiltro) => {
  const tenantId = getTenantToken();
  chavesFiltro.forEach((chaveFiltro) => {
    const url = `/public/relatorio/pdf?key=${btoa(chaveFiltro)}&t=${tenantId}`;
    window.open(url, '_blank');
  });
};

export const visualizarRelatorio = (id, modelo, parametros, parametrosAdicionais) => {
  const porta = getPortaFinanceiroApi();
  const tenantId = getTenantToken();
  const empresaId = getEmpresaId();

  let urlId = 'id=';
  if (Array.isArray(id)) {
    id.forEach((uuid) => {
      urlId += `${uuid},`;
    });
    urlId = urlId.slice(0, -1);
  } else {
    urlId += `${id}`;
  }

  let url = `/assets/html/visualizador.html?${urlId}&t=${tenantId}&empresaId=${empresaId}`;

  if (porta) {
    url += `&p=${porta}`;
  }

  url += `&modelo=${modelo}${parametros ? `&${parametros}` : ''}`;

  if (parametrosAdicionais) {
    url += `&paramsUrl=${btoa(parametrosAdicionais)}`;
  }

  window.open(url, '_blank');
};

export const visualizarRelatorioListagem = (modelo, parametros) => {
  const porta = getPortaFinanceiroApi();
  const tenantId = getTenantToken();
  const empresaId = getEmpresaId();

  const urlPorta = porta ? `&p=${porta}` : '';
  const urlParametros = parametros ? `&${parametros}` : '';

  const url = `/assets/html/visualizador.html?&t=${tenantId}&empresaId=${empresaId}${urlPorta}&modelo=${modelo}${urlParametros}`;

  window.open(url, '_blank');
};

export const getReCaptcha = () => {
  const reCaptcha = process.env.REACT_APP_RECAPTCHA;
  return reCaptcha;
};
